// Utility function to get session headers for API calls
export const getSessionHeaders = () => {
  const sessionId = localStorage.getItem('sessionId');
  if (!sessionId) {
    return {};
  }
  return {
    'x-session-id': sessionId
  };
};

// Custom error class for unauthorized responses
export class UnauthorizedError extends Error {
  constructor(message = 'Session expired. Please log in again.') {
    super(message);
    this.name = 'UnauthorizedError';
  }
}

// Helper function to silently re-authenticate
async function silentReAuth() {
  const storedUser = localStorage.getItem('user');
  if (!storedUser) {
    return null;
  }
  
  try {
    const user = JSON.parse(storedUser);
    const username = user.username;
    // For these accounts, password is same as username
    const password = username;
    
    const response = await fetch('/api/auth/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ username, password }),
    });
    
    const data = await response.json();
    
    if (data.success) {
      localStorage.setItem('sessionId', data.sessionId);
      localStorage.setItem('user', JSON.stringify(data.user));
      // Dispatch event to notify App component of session update
      window.dispatchEvent(new CustomEvent('sessionUpdated', { detail: { sessionId: data.sessionId, user: data.user } }));
      return data.sessionId;
    }
  } catch (err) {
    // Silent fail
  }
  
  return null;
}

// Helper function to make authenticated fetch calls
export const authenticatedFetch = async (url, options = {}) => {
  const sessionId = localStorage.getItem('sessionId');
  const headers = {
    ...options.headers,
    ...(sessionId ? { 'x-session-id': sessionId } : {})
  };
  
  let response = await fetch(url, {
    ...options,
    headers
  });
  
  // Check for 401 Unauthorized - automatically re-authenticate silently
  if (response.status === 401) {
    const newSessionId = await silentReAuth();
    
    if (newSessionId) {
      // Retry the original request with new session
      const retryHeaders = {
        ...options.headers,
        'x-session-id': newSessionId
      };
      
      response = await fetch(url, {
        ...options,
        headers: retryHeaders
      });
    }
    // If re-auth failed or still 401, just return the response
    // Don't throw - let the request fail naturally
  }
  
  return response;
};

